const version = '__@FLOPFLIP/VERSION_OF_RELEASE__';

export { addCommands, install } from './plugin';

export { version };
